import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  current: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  applicants: {
    isLoading: boolean;
    list: Record<string, any>[];
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  current: {
    isLoading: false,
    data: null,
    error: null,
  },
  applicants: {
    isLoading: false,
    list: [],
    error: null,
  },
};

export const { actions: attestationActions, reducer: attestationReducer } = createSlice({
  name: 'Attestation',
  initialState,
  reducers: {
    //Request
    setAttestationRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setAttestationRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setAttestationRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setAttestationRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //One
    setAttestationOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setAttestationOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setAttestationOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setAttestationOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
    //Current
    setAttestationCurrentRequest: (state) => {
      state.current = {
        ...state.current,
        isLoading: true,
        error: null,
      };
    },
    setAttestationCurrentSuccess: (state, { payload }) => {
      state.current = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setAttestationCurrentFailure: (state, { payload }) => {
      state.current = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setAttestationCurrentDefault: (state) => {
      state.current = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
    setAttestationApplicantsRequest: (state) => {
      state.applicants = {
        isLoading: true,
        list: [],
        error: null,
      };
    },
    setAttestationApplicantsSuccess: (state, actions) => {
      state.applicants = {
        isLoading: false,
        list: actions.payload,
        error: null,
      };
    },
    setAttestationApplicantsFailure: (state, actions) => {
      state.applicants = {
        isLoading: false,
        list: [],
        error: actions.payload.message,
      };
    },
    setAttestationApplicantsDefault: (state) => {
      state.applicants = {
        isLoading: false,
        list: [],
        error: null,
      };
    },
  },
});
